import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Entities } from '../../../../core/models/globals';
import { HeaderService } from '../../../../core/services/header.service';
import { NavigationService } from '../../../../core/services/navigation.service';

@Component({
  selector: 'app-reports-main-panel',
  templateUrl: './reports-main-panel.component.html',
  styleUrls: ['./reports-main-panel.component.scss']
})
export class ReportsMainPanelComponent implements OnInit {

  lastRefreshedTime: Date;
  depName: string;
  cloudType: string;
  isFromReports: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.cloudType = this.route.snapshot.params['cloudType'] || this.route.parent.snapshot.params['cloudType']
    this.navService.sendCloud(this.cloudType)
    this.navService.subNavData(Entities.Reports);
    this.depName = this.route.snapshot.params['deploymentName'] || this.route.parent.snapshot.params['deploymentName'];
    this.navService.sendLeftPanelIndex(0);
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

}
